import React from 'react';
import {
	Row, Col, Button, Form, DatePicker,
	message, Tooltip, Spin, Tag,
} from 'antd';
import {
	SearchOutlined, PrinterOutlined, DownloadOutlined,
} from '@ant-design/icons';
import jsPDF from 'jspdf';
import QRCode from 'qrcode.react';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import '../../assets/laporan.css';

const configClass = {
	title: 'Laporan SWDKLLJ',
	apiUrl: { data: 'laporan/api/kasir/' },
};

const config = new Config();

const NAVY     = '#0f2847';
const NAVY_MID = '#1a3a6b';

const SlipRow = ({ label, value, borderLeft, valueStyle = {} }) => (
	<div style={{
		display: 'flex', alignItems: 'baseline',
		padding: '9px 12px',
		borderLeft: borderLeft ? '1px solid rgba(0,0,0,0.08)' : undefined,
	}}>
		<span style={{ fontSize: 11, fontWeight: 600, color: '#64748b', minWidth: 80, flexShrink: 0 }}>{label}</span>
		<span style={{ fontSize: 11, color: '#475569', margin: '0 6px', flexShrink: 0 }}>:</span>
		<span style={{ fontSize: 12, fontWeight: 700, color: '#1e293b', flex: 1, ...valueStyle }}>{value}</span>
	</div>
);

const fmt = (v) => `Rp ${v != null ? Number(v).toLocaleString('id') : '0'}`;
const rp  = (v) =>        v != null ? Number(v).toLocaleString('id') : '0';

class LapSwdkllj extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading:    false,
			data:       null,
			err:        false,
			errMsg:     '',
			filter:     '',
			filterTgl:  null,
			mulai_dari: '',
			isPrinting:       false,
			isDownloadingPdf: false,
			isMobile:         window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	handleSubmit = () => {
		const { filterTgl } = this.state;
		if (!filterTgl) { message.warning('Pilih tanggal terlebih dahulu'); return; }
		const mulai_dari = filterTgl.format('DD-MM-YYYY');
		const filter     = `?mulai_dari=${mulai_dari}`;
		this.setState({ filter, mulai_dari });
		this.getData(filter);
	};

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data: this.props.responseMsg, err: false });
				} else {
					this.setState({ loading: false, data: null, err: true, errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false, data: null, err: true });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handlePrintPengantar = () => {
		const printEl = document.getElementById('pengantar-swdkllj-print');
		if (!printEl) return;
		this.setState({ isPrinting: true });

		const parent  = printEl.parentNode;
		const nextSib = printEl.nextSibling;
		printEl.style.display = 'block';
		document.body.appendChild(printEl);

		const siblings = Array.from(document.body.children).filter(el => el !== printEl);
		siblings.forEach(el => { el.style.display = 'none'; });

		window.print();

		siblings.forEach(el => { el.style.display = ''; });
		if (nextSib) parent.insertBefore(printEl, nextSib);
		else parent.appendChild(printEl);
		printEl.style.display = 'none';

		this.setState({ isPrinting: false });
	};

	handleDownloadPdfSlip = async () => {
		const { data, mulai_dari } = this.state;
		if (!data) return;
		const footer  = data?.footer;
		const sw      = data?.data?.swdkllj;
		const isValid = footer?.status_slipsetoran == 1;
		const noRef   = footer?.no_referensi;

		this.setState({ isDownloadingPdf: true });
		try {
			const MX = 8, MY = 8, W = 148;
			const CW = W - MX * 2;

			const C_NAVY  = [15, 40, 71];
			const C_GREEN = [21, 128, 61];
			const C_GRAY  = [100, 116, 139];
			const C_LGRAY = [226, 232, 240];
			const C_DARK  = [30, 41, 59];
			const rpFmt   = v => v != null ? Number(v).toLocaleString('id') : '0';

			// Load header image as base64 via canvas
			const headerImg = await new Promise(resolve => {
				const img = new Image();
				img.crossOrigin = 'anonymous';
				img.onload = () => {
					const c = document.createElement('canvas');
					c.width = img.naturalWidth; c.height = img.naturalHeight;
					c.getContext('2d').drawImage(img, 0, 0);
					resolve(c.toDataURL('image/png'));
				};
				img.onerror = () => resolve(null);
				img.src = process.env.PUBLIC_URL + '/header-slip-setoran.png';
			});

			const qrEl     = document.querySelector('.qr-slip-pdf-canvas canvas');
			const qrDataUrl = qrEl ? qrEl.toDataURL('image/png') : null;
			const hasQR     = !!(noRef && qrDataUrl);

			const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a5' });
			let y = MY;

			// ── Header image ──
			if (headerImg) {
				doc.addImage(headerImg, 'PNG', MX, y, CW, 18);
			} else {
				doc.setFillColor(...C_NAVY);
				doc.rect(MX, y, CW, 18, 'F');
				doc.setFontSize(9); doc.setFont(undefined, 'bold'); doc.setTextColor(255, 255, 255);
				doc.text('BANK PEMBANGUNAN DAERAH KALIMANTAN TENGAH', MX + CW / 2, y + 10, { align: 'center' });
			}

			// LEMBAR NASABAH chip (top-right corner overlay)
			doc.setFillColor(...C_NAVY);
			doc.roundedRect(W - MX - 30, MY + 2, 29, 5, 0.7, 0.7, 'F');
			doc.setFontSize(5.5); doc.setFont(undefined, 'bold'); doc.setTextColor(255, 255, 255);
			doc.text('LEMBAR NASABAH', W - MX - 15.5, MY + 5.8, { align: 'center' });
			y += 19;

			const tblTop = y;
			const sep  = yy => { doc.setDrawColor(...C_LGRAY); doc.setLineWidth(0.15); doc.line(MX, yy, MX + CW, yy); };
			const vsep = (x, y0, y1) => { doc.setDrawColor(...C_LGRAY); doc.setLineWidth(0.15); doc.line(x, y0, x, y1); };
			const dlbl = (t, x, yy) => { doc.setFontSize(5.5); doc.setFont(undefined, 'normal'); doc.setTextColor(...C_GRAY); doc.text(String(t), x + 2.5, yy + 3.5); };
			const dval = (t, x, yy, sz, bold, color, yOff) => {
				doc.setFontSize(sz || 8); doc.setFont(undefined, bold !== false ? 'bold' : 'normal');
				doc.setTextColor(...(color || C_DARK)); doc.text(String(t ?? ''), x + 2.5, yy + (yOff || 8.5));
			};

			// ── No. Referensi ──
			if (noRef) {
				const h = 11;
				doc.setFillColor(237, 243, 254); doc.rect(MX, y, CW, h, 'F');
				dlbl('No. Referensi', MX, y);
				doc.setFontSize(9); doc.setFont('courier', 'bold'); doc.setTextColor(...C_NAVY);
				doc.text(String(noRef), MX + 2.5, y + 9);
				sep(y + h); y += h;
			}

			// ── Rekening | Cabang ──
			const h1 = 11, midX = MX + CW / 2;
			dlbl('Rekening', MX, y);  dval('1000-103-001471', MX, y);
			dlbl('Cabang', midX, y);  dval(`CABANG ${footer?.upt || ''}`, midX, y);
			vsep(midX, y, y + h1); sep(y + h1); y += h1;

			// ── Samsat | Tanggal ──
			dlbl('Samsat', MX, y);  dval(footer?.nama_samsat || '', MX, y);
			dlbl('Tanggal', midX, y); dval(footer?.printed || '', midX, y);
			vsep(midX, y, y + h1); sep(y + h1); y += h1;

			// ── Berita ──
			const h2 = 9;
			dlbl('Berita', MX, y); dval('SETORAN SWDKLLJ / IWKBU', MX, y, 7.5, true, C_DARK, 7.5);
			sep(y + h2); y += h2;

			// ── Nominal (hero) ──
			const h3 = 15;
			doc.setFillColor(245, 248, 255); doc.rect(MX, y, CW, h3, 'F');
			dlbl('Nominal', MX, y);
			doc.setFontSize(14); doc.setFont(undefined, 'bold'); doc.setTextColor(...C_NAVY);
			doc.text(`Rp. ${rpFmt(sw?.jumlah)},00`, MX + 2.5, y + 12.5);
			sep(y + h3); y += h3;

			// ── Terbilang ──
			const h4 = 11;
			const terbilang = sw?.pokok > 0 ? (footer?.terbilang || '-') : '-';
			dlbl('Terbilang', MX, y);
			doc.setFontSize(6.5); doc.setFont(undefined, 'normal'); doc.setTextColor(...C_DARK);
			doc.text(doc.splitTextToSize(terbilang, CW - 5), MX + 2.5, y + 6.5);
			sep(y + h4); y += h4;

			// ── Teller | QR + Stempel ──
			const rColW   = 44;
			const splitX  = MX + CW - rColW;
			const tellerH = hasQR ? 28 : 22;

			dlbl('Teller', MX, y);
			doc.setFontSize(8.5); doc.setFont(undefined, 'bold'); doc.setTextColor(...C_DARK);
			doc.text('WINDA ARIANI', MX + 2.5, y + 8.5);
			vsep(splitX, y, y + tellerH);

			if (hasQR) {
				// QR code (left of right column)
				const qrX = splitX + 2.5, qrY = y + 4, qrS = 18;
				doc.setFillColor(255, 255, 255); doc.setDrawColor(...C_LGRAY); doc.setLineWidth(0.18);
				doc.roundedRect(qrX - 0.5, qrY - 0.5, qrS + 1, qrS + 1, 0.5, 0.5, 'FD');
				doc.addImage(qrDataUrl, 'PNG', qrX, qrY, qrS, qrS);
				doc.setFontSize(4.5); doc.setFont(undefined, 'normal'); doc.setTextColor(...C_GRAY);
				doc.text('SCAN', qrX + qrS / 2, qrY + qrS + 3.5, { align: 'center' });

				// Stempel (right of QR)
				const stX = splitX + 2.5 + qrS + 3, stY = y + 3, stW = rColW - qrS - 9.5, stH = tellerH - 5;
				if (isValid) {
					doc.setFillColor(220, 252, 231); doc.roundedRect(stX, stY, stW, stH, 1.2, 1.2, 'F');
					doc.setDrawColor(...C_GREEN); doc.setLineWidth(0.35); doc.roundedRect(stX, stY, stW, stH, 1.2, 1.2, 'S');
					doc.setFontSize(6.5); doc.setFont(undefined, 'bold'); doc.setTextColor(...C_GREEN);
					doc.text('TELAH', stX + stW / 2, stY + stH / 2 - 1, { align: 'center' });
					doc.text('VALIDASI', stX + stW / 2, stY + stH / 2 + 3.5, { align: 'center' });
				} else {
					doc.setDrawColor(...C_LGRAY); doc.setLineWidth(0.3);
					doc.roundedRect(stX, stY, stW, stH, 1.2, 1.2, 'S');
					doc.setFontSize(5); doc.setFont(undefined, 'normal'); doc.setTextColor(...C_GRAY);
					doc.text('TTD TELLER', stX + stW / 2, stY + stH / 2 - 1, { align: 'center' });
					doc.text('/ STEMPEL', stX + stW / 2, stY + stH / 2 + 3.5, { align: 'center' });
				}
			} else {
				// Stempel only (full right column)
				const stX = splitX + 2.5, stY = y + 2, stW = rColW - 5, stH = tellerH - 4;
				if (isValid) {
					doc.setFillColor(220, 252, 231); doc.roundedRect(stX, stY, stW, stH, 1.2, 1.2, 'F');
					doc.setDrawColor(...C_GREEN); doc.setLineWidth(0.35); doc.roundedRect(stX, stY, stW, stH, 1.2, 1.2, 'S');
					doc.setFontSize(7); doc.setFont(undefined, 'bold'); doc.setTextColor(...C_GREEN);
					doc.text('TELAH', stX + stW / 2, stY + stH / 2 - 1.5, { align: 'center' });
					doc.text('VALIDASI', stX + stW / 2, stY + stH / 2 + 4, { align: 'center' });
				} else {
					doc.setDrawColor(...C_LGRAY); doc.setLineWidth(0.3);
					doc.roundedRect(stX, stY, stW, stH, 1.2, 1.2, 'S');
					doc.setFontSize(6); doc.setFont(undefined, 'normal'); doc.setTextColor(...C_GRAY);
					doc.text('TANDA TANGAN', stX + stW / 2, stY + stH / 2 - 2, { align: 'center' });
					doc.text('TELLER / STEMPEL', stX + stW / 2, stY + stH / 2 + 3, { align: 'center' });
				}
			}

			sep(y + tellerH); y += tellerH;

			// ── Disclaimer ──
			const h5 = 13;
			doc.setFillColor(249, 250, 253); doc.rect(MX, y, CW, h5, 'F');
			doc.setFontSize(6.5); doc.setFont(undefined, 'bold'); doc.setTextColor(...C_NAVY);
			doc.text('BANK KALTENG — PT. Bank Pembangunan Daerah Kalimantan Tengah, Tbk', MX + 2.5, y + 4.5);
			doc.setFontSize(5.8); doc.setFont(undefined, 'normal'); doc.setTextColor(...C_GRAY);
			doc.text(
				doc.splitTextToSize('Slip ini merupakan bukti pembayaran yang sah atas setoran SWDKLLJ / IWKBU ke rekening resmi.', CW - 5),
				MX + 2.5, y + 9.5,
			);
			y += h5;

			// ── Outer border ──
			doc.setDrawColor(...C_NAVY); doc.setLineWidth(0.45);
			doc.rect(MX, tblTop, CW, y - tblTop);

			doc.save(`slip-swdkllj-${noRef || mulai_dari}.pdf`);
			message.success('PDF slip berhasil diunduh');
		} catch (err) {
			console.error('PDF slip error:', err);
			message.error('Gagal membuat PDF, silakan coba lagi');
		} finally {
			this.setState({ isDownloadingPdf: false });
		}
	};

	render() {
		const { loading, data, err, filterTgl, mulai_dari, isPrinting, isDownloadingPdf, isMobile } = this.state;

		const sw      = data?.data?.swdkllj;
		const footer  = data?.footer;
		const ttd     = data?.ttd;
		const isValid = footer?.status_slipsetoran == 1;

		const labelFilter = (txt) => (
			<span style={{ fontSize: 11, fontWeight: 600, color: '#475569', textTransform: 'uppercase', letterSpacing: .5 }}>{txt}</span>
		);

		return (
			<>
				<div>
					<Helmet>
						<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
						<style>{`
							.swdkllj-wrap .ant-form-item-label > label { font-weight: 600; color: #475569; font-size: 11px; }
							.swdkllj-wrap .ant-picker { border-radius: 8px !important; }
							#pengantar-swdkllj-print { display: none; }
						`}</style>
					</Helmet>

					<div className="swdkllj-wrap">
						<Row gutter={[0, 16]}>

							{/* ══ FILTER PANEL ══ */}
							<Col span={24}>
								<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(15,40,71,0.07)' }}>

									{/* Header */}
									<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
										<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
											<div style={{ width: 38, height: 38, background: 'rgba(251,191,36,0.15)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 19 }}>💳</div>
											<div>
												<div style={{ fontSize: 15, fontWeight: 700, color: '#fff' }}>{configClass.title}</div>
												<div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>Pengantar penyetoran dan slip setoran SWDKLLJ harian</div>
											</div>
										</div>
										{data && (
											<Tooltip title="Cetak Pengantar Penyetoran Uang">
												<Button
													icon={<PrinterOutlined />}
													loading={isPrinting}
													onClick={this.handlePrintPengantar}
													style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', color: '#fff', fontWeight: 600 }}
												>
													{!isMobile && 'Cetak Pengantar'}
												</Button>
											</Tooltip>
										)}
									</div>

									{/* Filter */}
									<div style={{ padding: '18px 20px 14px' }}>
										<Form layout="vertical" onFinish={this.handleSubmit} size="small" disabled={loading}>
											<div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
												<div style={{ flex: '0 0 220px' }}>
													<Form.Item label={labelFilter('Tanggal')} style={{ marginBottom: 0 }}>
														<DatePicker
															placeholder="dd-mm-yyyy" format="DD-MM-YYYY"
															style={{ width: '100%', borderRadius: 8 }}
															value={filterTgl}
															onChange={(date) => this.setState({ filterTgl: date })}
														/>
													</Form.Item>
												</div>
												<div style={{ display: 'flex', gap: 10 }}>
													<Button
														loading={loading} type="primary" htmlType="submit"
														disabled={loading} icon={!loading && <SearchOutlined />}
														style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 700, background: NAVY, borderColor: NAVY }}
													>
														Proses
													</Button>
													{data && (
														<Tooltip title="Cetak Pengantar Penyetoran Uang">
															<Button
																icon={<PrinterOutlined />}
																loading={isPrinting}
																onClick={this.handlePrintPengantar}
																style={{ borderRadius: 9, height: 36, paddingInline: 20, fontWeight: 600 }}
															>
																Cetak Pengantar
															</Button>
														</Tooltip>
													)}
												</div>
											</div>
										</Form>
									</div>
								</div>
							</Col>

							{/* ══ LOADING ══ */}
							{loading && (
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, padding: '36px', textAlign: 'center', border: '1px solid #e2e8f0' }}>
										<Spin size="large" />
										<div style={{ marginTop: 12, color: '#64748b', fontSize: 13 }}>Memproses laporan, mohon tunggu...</div>
									</div>
								</Col>
							)}

							{/* ══ EMPTY ══ */}
							{!data && !loading && !err && (
								<Col span={24}>
									<div style={{ background: '#fff', borderRadius: 14, padding: '48px 24px', textAlign: 'center', border: '1px solid #e2e8f0', color: '#aaa' }}>
										<div style={{ fontSize: 36, marginBottom: 12 }}>💳</div>
										<div style={{ fontSize: 14 }}>Pilih tanggal dan tekan <b>Proses</b> untuk menampilkan laporan</div>
									</div>
								</Col>
							)}

							{/* ══ ERROR ══ */}
							{err && !loading && (
								<Col span={24}>
									<div style={{ background: '#fff1f0', borderRadius: 14, padding: '36px 24px', textAlign: 'center', border: '1px solid #ffa39e', color: '#cf1322' }}>
										<div style={{ fontSize: 14, fontWeight: 600 }}>Gagal memuat laporan. Coba kembali.</div>
									</div>
								</Col>
							)}

							{/* ══ HASIL ══ */}
							{data && !loading && (
								<>
									{/* Status + Info Bar */}
									<Col span={24}>
										<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
											<div>
												<div style={{ fontSize: 15, fontWeight: 700, color: NAVY }}>Laporan SWDKLLJ — {footer?.nama_samsat}</div>
												<div style={{ fontSize: 12, color: '#64748b' }}>
													Tanggal: <b>{mulai_dari}</b>
													{footer?.upt && <span> &nbsp;·&nbsp; UPT: <b>{footer.upt}</b></span>}
												</div>
											</div>
											<Tag style={{ fontSize: 12, padding: '4px 14px', borderRadius: 20, fontWeight: 700, border: 'none',
												background: isValid ? '#dcfce7' : '#fef3c7',
												color:      isValid ? '#15803d' : '#b45309' }}>
												{isValid ? '✓ SLIP SETORAN TELAH VALIDASI' : '⚠ BELUM VALIDASI BANK'}
											</Tag>
										</div>
									</Col>

									{/* KPI Cards */}
									<Col span={24}>
										<div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
											<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, borderRadius: 14, padding: '18px 22px', flex: '1 1 180px', minWidth: 0, boxShadow: '0 4px 18px rgba(15,40,71,0.2)' }}>
												<div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>💰 TOTAL SWDKLLJ</div>
												<div style={{ fontSize: 20, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace', lineHeight: 1 }}>{fmt(sw?.jumlah)}</div>
											</div>
											<div style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', border: '1px solid #1d4ed822', boxShadow: '0 2px 12px #1d4ed814', flex: '1 1 150px', minWidth: 0 }}>
												<div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
													<div style={{ width: 32, height: 32, borderRadius: 9, background: '#1d4ed818', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}>💵</div>
													<span style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8 }}>Pokok SWDKLLJ</span>
												</div>
												<div style={{ fontSize: 16, fontWeight: 900, color: '#1d4ed8', fontFamily: 'monospace' }}>{fmt(sw?.pokok)}</div>
											</div>
											<div style={{ background: '#fff', borderRadius: 14, padding: '16px 20px', border: '1px solid #cf132222', boxShadow: '0 2px 12px #cf132214', flex: '1 1 150px', minWidth: 0 }}>
												<div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
													<div style={{ width: 32, height: 32, borderRadius: 9, background: '#cf132218', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}>⚠️</div>
													<span style={{ fontSize: 10, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: .8 }}>Denda SWDKLLJ</span>
												</div>
												<div style={{ fontSize: 16, fontWeight: 900, color: sw?.denda > 0 ? '#cf1322' : '#94a3b8', fontFamily: 'monospace' }}>{fmt(sw?.denda)}</div>
											</div>
										</div>
									</Col>

									{/* ── PENGANTAR PENYETORAN UANG ── */}
									<Col span={24}>
										<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)' }}>
											<div style={{ background: '#0f284708', padding: '12px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, borderBottom: '1px solid #0f284722' }}>
												<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
													<span style={{ fontSize: 16 }}>📄</span>
													<span style={{ fontSize: 13, fontWeight: 700, color: NAVY, textTransform: 'uppercase', letterSpacing: .8 }}>Pengantar Penyetoran Uang</span>
												</div>
												<Button size="small" icon={<PrinterOutlined />} loading={isPrinting} onClick={this.handlePrintPengantar}
													style={{ borderRadius: 8, fontSize: 12, fontWeight: 600 }}>
													Cetak
												</Button>
											</div>
											<div style={{ padding: '18px 24px' }}>
												<div style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>
													Tanggal: <b>{mulai_dari}</b>
												</div>
												<table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
													<tbody>
														{[
															{ label: '1. Pokok SWDKLLJ', value: sw?.pokok, accent: '#1d4ed8' },
															{ label: '2. Denda SWDKLLJ',  value: sw?.denda, accent: '#cf1322' },
														].map((row, i) => (
															<tr key={i} style={{ borderBottom: '1px dashed #e2e8f0' }}>
																<td style={{ padding: '10px 12px', color: '#334155', fontWeight: 600 }}>{row.label}</td>
																<td style={{ padding: '10px 4px', color: '#64748b', width: 20 }}>Rp.</td>
																<td style={{ padding: '10px 12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700, color: row.accent }}>{rp(row.value)}</td>
															</tr>
														))}
														<tr style={{ background: `${NAVY}0a` }}>
															<td style={{ padding: '12px', color: NAVY, fontWeight: 800, fontSize: 13 }}>TOTAL SWDKLLJ</td>
															<td style={{ padding: '12px 4px', color: '#64748b' }}>Rp.</td>
															<td style={{ padding: '12px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 900, fontSize: 15, color: NAVY }}>{rp(sw?.jumlah)}</td>
														</tr>
													</tbody>
												</table>
											</div>

											{/* TTD — 3 kolom */}
											{ttd && (
												<div style={{ padding: '16px 24px 24px', borderTop: '1px solid #f1f5f9' }}>
													<div style={{ fontSize: 11, color: '#64748b', textAlign: 'right', marginBottom: 16 }}>
														{footer?.upt}, TANGGAL {mulai_dari}
													</div>
													<div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
														{[ttd.kiri, ttd.tengah, ttd.kanan].map((t, i) => t && (
															<div key={i} style={{ flex: 1, textAlign: 'center' }}>
																<div style={{ fontSize: 12, color: '#64748b', fontWeight: 600 }}>{t.jabatan}</div>
																<div style={{ height: 56 }} />
																<div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 8 }}>
																	<div style={{ fontSize: 13, fontWeight: 700, color: NAVY }}><u>{t.nama}</u></div>
																	<div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>NIP : {t.nip}</div>
																</div>
															</div>
														))}
													</div>
												</div>
											)}
										</div>
									</Col>

									{/* ── SLIP SETORAN BANK ── */}
									<Col span={24}>
										<div style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(15,40,71,0.06)' }}>
											<div style={{ background: '#0f284708', padding: '12px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, borderBottom: '1px solid #0f284722' }}>
												<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
													<span style={{ fontSize: 16 }}>🏦</span>
													<span style={{ fontSize: 13, fontWeight: 700, color: NAVY, textTransform: 'uppercase', letterSpacing: .8 }}>Slip Setoran Bank</span>
												</div>
												<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
												<Tag style={{ fontSize: 12, padding: '3px 12px', borderRadius: 16, fontWeight: 700, border: 'none',
													background: isValid ? '#dcfce7' : '#fef3c7',
													color:      isValid ? '#15803d' : '#b45309' }}>
													{isValid ? '✓ TELAH VALIDASI' : '⚠ BELUM VALIDASI'}
												</Tag>
												{footer?.no_referensi && (
													<Button
														size="small"
														icon={<DownloadOutlined />}
														loading={isDownloadingPdf}
														onClick={this.handleDownloadPdfSlip}
														style={{ borderRadius: 8, fontSize: 12, fontWeight: 600 }}
													>
														{!isMobile && 'Unduh PDF'}
													</Button>
												)}
											</div>
											</div>

											{/* Slip content */}
											<div style={{ position: 'relative', overflow: 'hidden', padding: '0 5% 0' }}>
												{/* Watermark */}
												<img
													src={process.env.PUBLIC_URL + '/bg-slip-setoran-min.png'}
													style={{ position: 'absolute', top: 0, left: '5%', width: '90%', height: '100%', objectFit: 'fill', opacity: 0.23, zIndex: 0, pointerEvents: 'none' }}
												/>
												{/* Konten di atas watermark */}
												<div style={{ position: 'relative', zIndex: 1 }}>
													{/* Header bank + label lembar */}
													<div style={{ position: 'relative' }}>
														<img src={process.env.PUBLIC_URL + '/header-slip-setoran.png'} style={{ display: 'block', width: '100%' }} height="64" />
														<div style={{ position: 'absolute', top: 8, right: 10, background: 'rgba(255,255,255,0.85)', border: '1px solid #cbd5e1', borderRadius: 4, padding: '2px 10px', fontSize: 10, fontWeight: 800, color: '#475569', letterSpacing: 1, textTransform: 'uppercase' }}>
															LEMBAR NASABAH
														</div>
													</div>
													{/* Body slip */}
													<div style={{ padding: '10px 0 0' }}>
														{footer?.no_referensi && (
															<div style={{ borderBottom: '1px solid rgba(0,0,0,0.08)', background: `${NAVY}08` }}>
																<SlipRow label="No. Ref" value={footer.no_referensi} valueStyle={{ fontFamily: 'monospace', letterSpacing: .5, color: NAVY, fontWeight: 800 }} />
															</div>
														)}
														<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
															<SlipRow label="Rekening" value="1000-103-001471" />
															<SlipRow label="Cabang" value={`CABANG ${footer?.upt}`} borderLeft />
														</div>
														<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
															<SlipRow label="Samsat" value={footer?.nama_samsat} />
															<SlipRow label="Tanggal" value={footer?.printed} borderLeft />
														</div>
														<div style={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
															<SlipRow label="Berita" value="SETORAN SWDKLLJ / IWKBU" />
														</div>
														<div style={{ borderBottom: '1px solid rgba(0,0,0,0.08)', background: 'rgba(15,40,71,0.03)' }}>
															<SlipRow label="Nominal" value={`Rp. ${rp(sw?.jumlah)},00`} valueStyle={{ fontSize: 15, fontWeight: 900, color: NAVY }} />
														</div>
														<div style={{ borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
															<SlipRow label="Terbilang" value={sw?.pokok > 0 ? footer?.terbilang : '-'} valueStyle={{ fontStyle: 'italic' }} />
														</div>
														<div style={{ display: 'grid', gridTemplateColumns: '1fr auto', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
															<SlipRow label="Teller" value="WINDA ARIANI" />
															<div style={{ borderLeft: '1px solid rgba(0,0,0,0.08)', padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
																{footer?.no_referensi && (
																	<div className="qr-slip-pdf-canvas" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
																		<QRCode
																			value={`${window.location.protocol}//${window.location.host}/verifikasi/slip/${footer.no_referensi}`}
																			size={72}
																			style={{ flexShrink: 0 }}
																		/>
																		<span style={{ fontSize: 8, color: '#94a3b8', letterSpacing: .3, textAlign: 'center' }}>SCAN VERIFIKASI</span>
																	</div>
																)}
																<div style={{ width: 110, height: 56, border: '1.5px dashed #94a3b8', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', background: isValid ? 'rgba(21,128,61,0.06)' : 'rgba(255,255,255,0.6)' }}>
																	{isValid
																		? <div style={{ textAlign: 'center' }}><div style={{ fontSize: 16 }}>✓</div><div style={{ fontSize: 9, fontWeight: 800, color: '#15803d', letterSpacing: .5 }}>TELAH VALIDASI</div></div>
																		: <div style={{ fontSize: 9, color: '#94a3b8', textAlign: 'center', lineHeight: 1.4 }}>TANDA TANGAN<br />TELLER / STEMPEL</div>
																	}
																</div>
															</div>
														</div>
														<div style={{ padding: '8px 12px', borderTop: '2px solid rgba(0,0,0,0.10)', display: 'flex', alignItems: 'center', gap: 8, background: 'rgba(15,40,71,0.02)' }}>
															<span style={{ fontSize: 10, color: '#0f2847' }}>🏦</span>
															<span style={{ fontSize: 10, color: '#475569', fontStyle: 'italic', lineHeight: 1.4 }}>
																PT. Bank Pembangunan Daerah Kalimantan Tengah, Tbk menyatakan slip ini sebagai bukti pembayaran yang sah.
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									{/* Grand Total Bar */}
									<Col span={24}>
										<div style={{ background: `linear-gradient(135deg, ${NAVY} 0%, ${NAVY_MID} 100%)`, borderRadius: 14, padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, boxShadow: '0 4px 20px rgba(15,40,71,0.2)' }}>
											<div>
												<div style={{ fontSize: 11, color: '#64748b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>TOTAL SWDKLLJ — {mulai_dari}</div>
												<div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
													<div style={{ fontSize: 11, color: '#94a3b8' }}>Pokok: <span style={{ color: '#cbd5e1', fontWeight: 600 }}>{fmt(sw?.pokok)}</span></div>
													<div style={{ fontSize: 11, color: '#94a3b8' }}>Denda: <span style={{ color: '#cbd5e1', fontWeight: 600 }}>{fmt(sw?.denda)}</span></div>
												</div>
											</div>
											<div style={{ fontSize: 26, fontWeight: 900, color: '#fbbf24', fontFamily: 'monospace' }}>{fmt(sw?.jumlah)}</div>
										</div>
									</Col>
								</>
							)}
						</Row>
					</div>
				</div>

				{/* ══ PRINT AREA — Pengantar Penyetoran Uang ══ */}
				{/* Tersembunyi di layar, hanya muncul saat window.print() dipanggil */}
				<div id="pengantar-swdkllj-print" style={{ display: 'none' }}>
					{data && (
						<div className="kertas-laporan">
							<div className="judul-laporan" style={{ borderBottom: 'double 5px #000', textAlign: 'center' }}>
								<strong>PENGANTAR PENYETORAN UANG</strong>
								<br />
								TANGGAL : {mulai_dari}
							</div>
							<br />
							<table className="laporan-table" border="1" cellPadding="5" style={{ width: '100%', border: '1px dotted #000' }}>
								<tbody>
									<tr>
										<td>1. POKOK SWDKLLJ</td>
										<td>Rp.</td>
										<td className="teks-kanan">{rp(sw?.pokok)}</td>
									</tr>
									<tr>
										<td>2. DENDA SWDKLLJ</td>
										<td>Rp.</td>
										<td className="teks-kanan">{rp(sw?.denda)}</td>
									</tr>
									<tr>
										<td className="teks-kanan"><strong>TOTAL SWDKLLJ</strong></td>
										<td>Rp.</td>
										<td className="teks-kanan"><strong>{rp(sw?.jumlah)}</strong></td>
									</tr>
								</tbody>
							</table>
							{ttd && (
								<Row justify="space-between" style={{ marginTop: 10 }}>
									<Col span={24} className="teks-kanan">
										{footer?.upt}, TANGGAL {mulai_dari}
									</Col>
									{[
										{ t: ttd.kiri,   prefix: 'NPP' },
										{ t: ttd.tengah, prefix: 'NIP' },
										{ t: ttd.kanan,  prefix: 'NIP' },
									].map(({ t, prefix }, i) => t && (
										<Col key={i} span={8} className="teks-tengah" style={{ marginTop: 20 }}>
											{t.jabatan}
											<div style={{ marginTop: 50 }}>
												<strong><u>{t.nama}</u></strong><br />
												{prefix} : {t.nip}
											</div>
										</Col>
									))}
								</Row>
							)}
						</div>
					)}
				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(LapSwdkllj);
